module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.6e435534.ttf";